import {AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatStepper} from '@angular/material';
import {DelegationListComponent} from '../delegation-list/delegation-list.component';
import {MatOption, MatCheckboxChange, MatSelect} from '@angular/material';
import {DelegationService} from '../delegation.service';
import {
    DelegationHabilitationParams,
    DelegationItem,
    DelegationRequestModel, DelegationUo, DelegationUoVo, TypeSelectDelegation
} from 'app/modules/delegation/delegation.model';
import {indexOf} from 'lodash';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-modal-edit-delegation',
    templateUrl: './modal-edit-delegation.component.html',
    styleUrls: ['./modal-edit-delegation.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class ModalEditDelegationComponent implements OnInit, AfterViewInit, OnDestroy {


  constructor(private _formBuilder: FormBuilder,
                public dialog: MatDialog,
                public dialogRef: MatDialogRef<DelegationListComponent>,
                private delegationService: DelegationService,
                private toastrService: ToastrService,
                private translate: TranslateService,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        translate.setDefaultLang('fr');
    }

  uoList = [];
  uoDefaultList = [];
  delegationsDefaultList = [];
  delegates = [];
  authorizations: DelegationHabilitationParams[];
  authorizationDelegations: Array<DelegationHabilitationParams> = [];
  user = new FormControl();
  account = new FormControl();
  color = 'accent';
  allHabilitationsChecked = false;
  selected: DelegationItem ;

  allSelected = false;
  @ViewChild('select') unitSelect: MatSelect;
  @ViewChild('select') collabSelect: MatSelect;

  ngOnInit() {
    this.selected = this.data.delegator;
     this.authorizations = [
      {
        id: 1,
        label: 'INJECTION',
        title: 'Validation des injections unitaires',
        startDate: '',
        endDate: '',
        activate: false,
      },
      {
        id: 2,
        label: 'REOUVERTURE',
        title: 'Réouverture des fiches',
        startDate: '',
        endDate: '',
        activate: false,
      },
      {
        id: 3,
        label: 'DEVEROUILLAGE',
        title: 'Déverrouillage des fiches',
        startDate: '',
        endDate: '',
        activate: false,
      },
      {
        id: 4,
        label: 'VALIDATION',
        title: 'Validation des fiches',
        startDate: '',
        endDate: '',
        activate: false,
      },
       {
         id: 5,
         label: 'INJECTION EN MASSE',
         title: 'Validation des injections en masse',
         startDate: '',
         endDate: '',
         activate: false,
       }
    ];
    this.allHabilitationsChecked = false;
    this.loadDelegations(this.selected.dirSite);
    this.authorizations.forEach(auth => {
        if (this.selected.delegationHabilitation.delegationHabilitationParamsVO.id === auth.id) {
            auth.activate = true;
        }
        // Translate the 'title' property
      auth.title = this.translate.instant(auth.title);
    });
  }
  // Event fired after view is initialized
  ngAfterViewInit() {
  }

  onToppingRemoved(topping: string, formControl) {
    const toppings = this.user.value as string[];
    this.removeFirst(toppings, topping);
    formControl.setValue(toppings); // To trigger change detection
  }

  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  toggleChanged() {
    this.delegationService.selectAllHabilitationsSubject$.next(this.allHabilitationsChecked);
  }

  cancel() {
    this.dialogRef.close();
  }

  loadDelegations(matricule: string) {
    this.delegationService.loadAllDelegation(matricule).subscribe(res => {
      this.uoList = res.Uos;
      this.delegates = res.delegates;
      this.delegates = this.delegates.filter(del=> del.matricule!=matricule);
      // set default values of UOs and delegators select
      this.uoDefaultList = this.mapUoDefaultList(this.selected.delegationUoList);
      const matchingUos = this.uoList.filter(uo => this.uoDefaultList.some(defaultUo => defaultUo.name === uo.name));
      const matchingDelagators = this.delegates.filter(delegator => delegator.matricule === this.selected.delegate );
      this.user.setValue(matchingUos);
      this.account.setValue(matchingDelagators);
    });
  }

   mapUoDefaultList(originalList: DelegationUo[]): any[] {
    return originalList.map(original => ({
      code: original.label,
      id: original.uoId,
      level: 'BU',
      name: original.name
    }));
  }

  onUserEmitter(user: any) {
    this.user = user;
  }

  onAccountEmitter(user: any) {
    this.user = user;
  }

  onDelegationEmitter(updatedObject: DelegationHabilitationParams) {
    const indexAutorizaation = this.authorizations.findIndex(auth => auth.id === updatedObject.id);
    if (indexAutorizaation > -1) {
      // If found, update the existing object with the new data
      this.authorizations[indexAutorizaation].activate = updatedObject.activate;
    }
    if (updatedObject.activate) {
      // If activate is true, find the index of the existing object based on the title
      const index = this.authorizationDelegations.findIndex(delegation => delegation.id === updatedObject.id);
      if (index > -1) {
        // If found, update the existing object with the new data
        this.authorizationDelegations[index] = updatedObject;
      } else {
        // If not found, push the new object to the list
        this.authorizationDelegations.push(updatedObject);
      }
    } else {
      // If activate is false, find the index of the existing object based on the title
      const index = this.authorizationDelegations.findIndex(delegation => delegation.id === updatedObject.id);

      if (index > -1) {
        // If found, remove the existing object from the list
        this.authorizationDelegations.splice(index, 1);
      }
    }
  }

  onToggleItemChanged(isChecked: boolean) {
    this.allHabilitationsChecked = this.checkAllAuthorizationsSelected();
  }

  checkAllAuthorizationsSelected(): boolean {
    return this.authorizations.every(auth => auth.activate);
  }
  hasNullDates() {
    let hasNull = false;

    for (const item of this.authorizationDelegations) {
      if (item.startDate === null || item.endDate === null) {
        hasNull = true;
        break;
      }
    }
    return hasNull;
    // return  this.authorizationDelegations.some(item => item.startDate === null || item.endDate === null);
  }

  validate() {
    if (this.account.value.length === 0 || this.user.value.length === 0) {
        this.toastrService.error('Les UOs et les collaborateurs sont obligatoires');
    } else if (this.hasNullDates()) {
        this.toastrService.error('Les dates de délégation sont obligatoires');
    } else {
      const delegationRequestList: DelegationRequestModel[] = [];

      for (const delegation of this.authorizationDelegations) {
        for (const accountValue of this.account.value) {
          const delegationRequest: DelegationRequestModel = {
            id: this.getDelegationId(delegation),
            createdBy: this.selected.createdBy,
            delegate: accountValue.matricule,
            fullName: accountValue.fullName,
            delegationParams: {
              id: delegation.id,
              endDate: delegation.endDate,
              startDate: delegation.startDate
            },
            delegationUoVo: this.mapObjects(this.user.value),
            deleted: false,
            site:null,
            dirSite: this.selected.dirSite,
            function: 'OPERATIONS MANAGER'
          };
          delegationRequestList.push(delegationRequest);
        }
      }
      this.delegationService.saveBulkDelegation(this.selected.dirSite, delegationRequestList).subscribe(res => {
        this.dialogRef.close();
        console.log('res: ', res);
        this.delegationService.redirectTo('delegation');
      });
    }
  }

  getDelegationId(delegation) {
    return this.data.delegator.delegationHabilitation.delegationHabilitationParamsVO.id === delegation.id ? this.data.delegator.id : null ;
  }
  mapObjects(UOList: any[]): DelegationUoVo[] {
    const targetList: DelegationUoVo[] = [];

    for (const uo of UOList) {
      const delegationUO: DelegationUoVo = {
        createdBy: null,
        deleted: false,
        label: uo.code,
        name: uo.name,
        uoId: uo.id,
        updatedBy: null,
      };

      targetList.push(delegationUO);
    }
    return targetList;
  }





  ngOnDestroy(): void {
    // this.allHabilitationsChecked = false ;
  }

  protected readonly TypeSelectDelegation = TypeSelectDelegation;
}



// WEBPACK FOOTER //
// ./src/app/modules/delegation/modal-edit-delegation/modal-edit-delegation.component.ts